import { FC } from 'react'

import { Alert } from '@mui/material'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import { warningTriangle } from 'api/apiContstants'
import FadeAnimationDiv from 'components/common/Animations'
import { useTheme } from 'themes'

import { newFormThemeOverrides } from '../../styles'
import { IWarningAuthenticator } from '../../types'

const AuthenticatorWarning: FC<IWarningAuthenticator> = ({ textType, alertText }) => {
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })

    return (
        <FadeAnimationDiv>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={formTheme}>
                    <Alert data-sta-id="Alert-AuthenticatorWarning" icon={false} className="error authenticatorWarning">
                        <div className="iconBox">
                            <img className="iconImg" src={warningTriangle} alt="Warning" />
                        </div>
                        <div className="message">
                            <span className="textWrap">
                                <span className="type--no-caps">{textType}:</span>
                                <span className="text">{alertText}</span>
                            </span>
                        </div>
                    </Alert>
                </ThemeProvider>
            </StyledEngineProvider>
        </FadeAnimationDiv>
    )
}

export default AuthenticatorWarning
